<template>
  <div class="rightPage">
    <div class="rightHeader">
      <v-search
        :formContent="formContent"
        :SearchForm="SearchForm"
        :inline="true"
        :optareBtn="optareBtn"
        :treePathObj="treePathObj"
        @resetFn="resetFn"
        @searchFn="searchFn"
        @confirmFn="getListFn"
        @nodeClick="nodeClick"
        @addFn="addFn"
        @delFn="delFn"
        @dataImportFn="dataImportFn"
        @editScopeFn="editScopeFn"
        @netFn="netFn"
        @calibrationFn="calibrationFn"
        @calibrationImportFn="calibrationImportFn"
        @calibrationExpiredFn="calibrationExpiredFn"
      />
    </div>
    <!-- table -->
    <div class="componentPage">
      <unbind-table
        :loading="loading"
        ref="table"
        :tableData="tableData"
        @choozeTable="choozeTable"
        @editFn="editFn"
        @delRowFn="delRowFn"
        @detailFn="detailFn"
        @calibrationSignleFn="calibrationSignleFn"
      />

      <Pager
        ref="pager"
        :total="total"
        :size="SearchForm.iDisplayLength"
        @currentChange="getListFn"
      ></Pager>
      <!--      <Pagination-->
      <!--        class="pagination"-->
      <!--        :total="total"-->
      <!--        :page.sync="SearchForm.iDisplayStart"-->
      <!--        :limit.sync="SearchForm.iDisplayLength"-->
      <!--        @pagination="getListFn"-->
      <!--      ></Pagination>-->
    </div>
    <!--  未确认的新增&编辑 -->
    <unbind-dialog
      :optareStatus="optareStatus"
      :title="unTitle"
      :editObj="editObj"
      :isShowUnDialog.sync="isShowUnDialog"
      ref="chilren"
      v-bind="$attrs"
    />
    <!-- 传感器导入 -->
    <unkonw-import :isShowImDialog.sync="isShowImDialog" ref="importDia" />
    <!-- 修改范围 -->
    <v-scope
      :isShowConfig.sync="isShowScope"
      :scopeArray="scopeArray"
      ref="scopedId"
    ></v-scope>
    <!-- 绑定配置信息模态框 -->
    <!-- <v-config ref="config" :isShowConfig.sync="isShowConfig" :rowData="rowData" v-bind="$attrs"
  :useFuncType="useFuncType" v-if="isShowConfig" :sensorWay="sensorWay" /> -->
    <!-- 详情 -->
    <!--    <v-detail-->
    <!--      ref='detail'-->
    <!--      :isShowDetail.sync='detailIsShow'-->
    <!--      :title='detailTitle'-->
    <!--      :baseMsg='baseMsg'-->
    <!--      :detailObj='detailObj'-->
    <!--      :deviceType='deviceType'-->
    <!--      :deviceProperty='deviceProperty'-->
    <!--      :detailLoading='detailLoading'-->
    <!--      :detailRuleObj='detailRuleObj'-->
    <!--      :detailNetObj='detailNetObj'-->
    <!--      v-bind='$attrs'-->
    <!--      :sensorWay='sensorWay'-->
    <!--      @changdetail='changdetail'-->
    <!--    />-->
    <SensorDetailDialog></SensorDetailDialog>
    <!-- 网络参数上报规则模态框  -->
    <v-net
      :isShow.sync="isShow"
      :choozeTableData="choozeTableData"
      :useFuncId="useFuncId"
      :useFuncType="useFuncType"
      ref="vForm"
    />
    <!-- 校准模态框 -->
    <CalibrationDialog
      v-if="isShowCalibration"
      :isShow.sync="isShowCalibration"
      :choozeTableData="choozeTableData"
      :rowData="rowData"
      :singleCalibration="singleCalibration"
    >
    </CalibrationDialog>
    <!-- 标准导入模态框 -->
    <CalibrationImport
      :isShow.sync="isShowCaliImport"
      :choozeTableData="choozeTableData"
    >
    </CalibrationImport>
    <!-- 标准过期模态框 -->
    <CalibrationExpired
      v-if="isShowCaliExpired"
      :isShow.sync="isShowCaliExpired"
    >
    </CalibrationExpired>
  </div>
</template>

<script>
import { sensorList } from '@/api/api'
import {
  sensorDeleteSensor,
  sensorGetSensorDetailInfo
} from '@/api/modules/sensor.js'
import { shareScope } from '@/api/modules/public.js'
import netParam from '../NetParam.vue'
import tableUnBind from './UnKnowTable.vue'
import unbindKnow from './Diolag.vue'
import importDialog from './sensorImport.vue'
import editScope from '../EditScope.vue'

import bus from '@/utils/bus.js'
import getAllTreePath from '@/utils/getAllTreePath.js'
import { getIsPlatform } from '@/utils/permission'
import SensorDetailDialog from '@/components/dialog/sensorDetail/sensorDetailDialog.vue'
import Pager from '@/components/Pagination/src/Pager.vue'
import CalibrationDialog from '../CalibrationDialog.vue'
import CalibrationImport from '../CalibrationImport.vue'
import CalibrationExpired from '../CalibrationExpired.vue'

export default {
  name: 'unKnowPage',
  components: {
    Pager,
    SensorDetailDialog,
    'v-net': netParam,
    'unbind-table': tableUnBind,
    'unbind-dialog': unbindKnow,
    'unkonw-import': importDialog,
    'v-scope': editScope,
    // 'v-config': ConfigDialogVue,
    // 'v-detail': detailDialog
    CalibrationDialog,
    CalibrationImport,
    CalibrationExpired
  },
  props: {
    selectDeviceType: {
      type: Array
    }
  },
  watch: {
    selectDeviceType: {
      handler (newVal) {
        this.formContent[1].selectParam = newVal
      },
      immediate: true
    }
  },
  mixins: [getAllTreePath],
  data () {
    return {
      formContent: [
        {
          id: 1,
          text: 'public.table_code',
          type: 'input',
          paramsName: 'tagId',
          isChooze: true
        },
        {
          id: 6,
          text: 'device.sensor_type',
          type: 'select',
          paramsName: 'sensorType',
          isChooze: false,
          selectParam: []
        }
      ],
      SearchForm: {
        tagId: null,
        scopeName: null,
        sensorType: null,
        iDisplayStart: 0,
        iDisplayLength: 15
      },
      total: 0,
      loading: false,
      tableData: [],
      title: '',
      isShow: false,
      useFuncId: '',
      optareBtn: [
        {
          id: 1,
          icon: '',
          vHas: ['incubatorAddCarrier'],
          text: 'public.btn_new',
          method: 'addFn'
        },
        {
          id: 4,
          icon: '',
          vHas: ['incubatorAddCarrier'],
          text: 'public.tbopt_delete',
          method: 'delFn'
        },
        // {
        //   id: 2,
        //   icon: '',
        //   vHas: ['incubatorDelCarrier'],
        //   text: 'public.net_param',
        //   method: 'netFn'
        // },
        // {
        //   id: 3,
        //   icon: '',
        //   vHas: ['incubatorDelCarrier'],
        //   text: 'public.escalation_rules',
        //   method: 'netFn'
        // },
        // {
        //   id: 5,
        //   icon: '',
        //   vHas: ["incubatorAddCarrier"],
        //   text: $t('integration.form_template'),
        //   method: 'tableTemplateFn'
        // },
        {
          id: 6,
          icon: '',
          vHas: ['incubatorAddCarrier'],
          text: 'device.import_data',
          method: 'dataImportFn'
        },

        {
          id: 7,
          icon: '',
          vHas: ['incubatorAddCarrier'],
          text: 'device.modify_customer',
          method: 'editScopeFn'
        }
      ],
      sensorWay: 'unknown',
      // 勾选的表格数据
      choozeTableData: [],
      // 区分六种情况下的表单
      useFuncType: '',
      rowData: null,
      // 未确认
      isShowUnDialog: false,
      isShowImDialog: false,
      unTitle: '',
      optareStatus: '',
      // 修改范围
      isShowScope: false,
      scopeArray: [],
      // 详情
      baseMsg: [
        {
          text: 'public.belong',
          key: 'url',
          content: ''
        },
        {
          text: 'device.sensor_code',
          key: 'tag_id',
          content: ''
        },
        {
          text: 'device.sensor_type',
          key: 'type',
          content: ''
        },

        {
          text: 'device.sensor_status',
          key: 'status',
          content: ''
        },
        // {
        //   text: 'device.config_status',
        //   key: 'config_status',
        //   content: ''
        // },
        {
          text: 'public.table_create_time',
          key: 'create_time',
          content: ''
        },
        {
          key: 'nickname',
          text: 'device.nickname',
          content: ''
        },
        {
          key: 'description',
          text: $t('public.table_desc'),
          content: ''
        }
      ],
      detailIsShow: false,
      detailTitle: '',
      // 传感器的基础信息
      detailObj: {},
      // 属性的健名
      deviceType: {},
      // 属性的对应值
      deviceProperty: {},
      detailRuleObj: [
        {
          key: 'collectInterval',
          text: 'device.sample_interval',
          isBool: true
        },
        {
          key: 'exCollectInterval',
          text: 'device.exception_sample_interval',
          isBool: true
        },
        {
          key: 'tempCollectInterval',
          text: $t('integration.temperature_acquisition_interval'),
          isBool: true
        },
        {
          key: 'tempChange',
          text: $t('integration.temperature_change_threshold'),
          isBool: true
        },
        {
          key: 'tempMaxReport',
          text: $t('integration.maximum_temperature_reporting_interval'),
          isBool: true
        },
        {
          key: 'tempMinReport',
          text: $t('integration.minimum_temperature_reporting_interval'),
          isBool: true
        },

        {
          key: 'humCollectInterval',
          text: $t('integration.humidity_collection_interval'),
          isBool: true
        },
        {
          key: 'humChange',
          text: $t('integration.humidity_change_threshold'),
          isBool: true
        },
        {
          key: 'humMaxReport',
          text: $t('integration.maximum_humidity_reporting_interval'),
          isBool: true
        },
        {
          key: 'humMinReport',
          text: $t('integration.humidity_minimum_reporting_interval'),
          isBool: true
        }
      ],
      detailNetObj: [
        {
          key: 'extPanId',
          text: 'Ext Pan ID',
          isBool: true
        },
        {
          key: 'channelPage',
          text: 'Join Attemp',
          isBool: true
        },
        {
          key: 'transmitPower',
          text: 'device.transmit_power',
          isBool: true
        },
        {
          key: 'channelMask',
          text: 'device.channel_mask',
          isBool: true
        },
        {
          key: 'inNetInterval',
          text: 'device.in_net_interval',
          isBool: true
        },
        {
          key: 'devEui',
          text: 'DevEUI',
          isBool: true
        },
        {
          key: 'appEui',
          text: 'AppEUI',
          isBool: true
        },
        {
          key: 'appKey',
          text: 'AppKey',
          isBool: true
        }
      ],
      detailLoading: false,
      // 編輯
      editObj: {},

      isShowCalibration: false,
      isShowCaliImport: false,
      isShowCaliExpired: false,
      singleCalibration: false
    }
  },
  mounted () {
    bus.$off('nodeClickFn')

    bus.$on('nodeClickFn', row => {
      // 获取完整的路径
      this.getAllPath(row)
      if (row.id === 'all') {
        this.SearchForm.sceneId = null
        this.SearchForm.scopeName = null
      }
      // 一级范围
      else if (row.level === 0 && row.id !== 'all') {
        this.SearchForm.sceneId = null
        this.SearchForm.scopeName = row.label
      } else {
        this.SearchForm.scopeName = null
        this.SearchForm.sceneId = row.sceneId
      }
      this.getListFn()
    })
    if (getIsPlatform()) {
      this.SearchForm.scopeName = this.$store.state.SchemaTree[1].label
      this.treePathObj = this.$store.state.SchemaTree[1].label
    } else {
      this.SearchForm.scopeName = this.$store.state.SchemaTree[0].label
      this.treePathObj = this.$store.state.SchemaTree[0].label
    }
    this.getListFn()
  },
  methods: {
    searchFn () {
      this.SearchForm.iDisplayStart = 0
      this.$refs.pager.reset()
      this.getListFn()
    },
    /** 网络参数& 上报规则 */
    netFn (row) {
      // row.id === 2 为网关  === 3 为规则
      if (this.choozeTableData.length === 0) {
        return this.$message.warning(this.$t('public.least_one_data'))
      }

      const flag = this.distinguishTypeFn('type')
      if (!flag) {
        return this.$message.error(
          $t(
            'integration.please_select_the_same_temperature_or_temperature_humidity_sensor'
          )
        )
      }

      this.useFuncId = row.id
      this.useFuncType = this.choozeTableData[0].type
      this.isShow = true

      this.$nextTick(() => {
        this.$refs.vForm.clearValidate()
        // 将dioForm数据init
        const OBJ = this.$refs.vForm.dioForm
        for (const key in OBJ) {
          this.$set(OBJ, key, null)
        }
      })
    },
    /** 分页 */
    getListFn ({ iDisplayStart, iDisplayLength } = {}) {
      if (iDisplayLength) {
        this.SearchForm.iDisplayStart = iDisplayStart
        this.SearchForm.iDisplayLength = iDisplayLength
      }
      this.loading = true

      sensorList(this.SearchForm, this.sensorWay)
        .then(({ result, pageInfo }) => {
          this.tableData = result
          this.total = pageInfo.total
        })
        .finally(() => {
          this.loading = false
        })
    },
    /** 重置 */
    resetFn () {
      this.SearchForm = {
        tagId: null,
        sensorType: null,
        scopeName: null,
        iDisplayStart: 0,
        iDisplayLength: 15
      }
      bus.$emit('initTree')
      if (getIsPlatform()) {
        this.SearchForm.scopeName = this.$store.state.SchemaTree[1].label
        this.treePathObj = this.$store.state.SchemaTree[1].label
      } else {
        this.SearchForm.scopeName = this.$store.state.SchemaTree[0].label
        this.treePathObj = this.$store.state.SchemaTree[0].label
      }
      this.getListFn()
    },
    /** 特殊处理 */
    nodeClick (option) {
      for (const key in this.SearchForm) {
        if (key === 'undefined') {
          delete this.SearchForm[key]
        }
      }
      this.SearchForm.sceneId = option.label.sceneId
      // this.$set(this.SearchForm,'sceneId',option.label.sceneId);
    },

    /** 区分勾选中的数据是否是同一种类型 */
    distinguishTypeFn (str) {
      if (this.choozeTableData.length === 1) return true
      const oneParam = this.choozeTableData[0]
      let flag = true
      for (const item of this.choozeTableData) {
        if (oneParam.str !== item.str) {
          flag = false
          break
        } else {
          flag = true
        }
      }
      return flag
    },

    choozeTable (row) {
      this.choozeTableData = row
    },

    getGenerValueFn (array = [], obj) {
      array.forEach(item => {
        for (const newKey in obj) {
          item.key === newKey ? (item.content = obj[newKey]) : null
        }
      })
    },
    changdetail (row) {
      this.detailFn(row)
    },
    /** 详情跳转 */
    detailFn (row) {
      console.log(row)

      bus.$emit('sensorParam', row.id, row.tagId)
      return

      this.detailTitle = `[${row.tagId}]` + this.$t('public.details')
      this.detailIsShow = true
      this.detailLoading = true
      sensorGetSensorDetailInfo(row.id)
        .then(({ result, state }) => {
          result.sensor.pictureBase64 =
            result.sensor.pictureBase64 || result.deviceType.pictureBase64
          this.detailObj = result.sensor
          this.deviceType = result.deviceType
          this.deviceProperty = result.deviceProperty || {}
          const { sensor, appConfig, netConfig } = result
          // 基本的数据
          sensor.create_time = this.$timetransition(sensor.create_time)
          this.baseMsg.forEach(item => {
            for (const newKey in sensor) {
              item.key === newKey ? (item.content = sensor[newKey]) : null
              if (item.key === 'url') {
                item.content = sensor.fullPath || sensor.scopeName
              }
            }
          })
          this.getGenerValueFn(this.detailRuleObj, appConfig)
          this.getGenerValueFn(this.detailNetObj, netConfig)
        })
        .finally(() => {
          this.detailLoading = false
        })
    },
    /** 应用配置 */
    // configFn(row) {
    //   this.rowData = { ...row }
    //   this.useFuncType = row.type
    //   this.isShowConfig = true
    //   this.$nextTick(() => {
    //     this.$refs['config'].activeName = 'rule'
    //     this.$refs['config'].componentContent = 'rule'
    //   })
    // },
    /** 单条删除 */
    delRowFn (row) {
      this.$confirm(
        this.$t('messageTitle.DeleteToContinue'),
        this.$t('public.prompt'),
        {
          confirmButtonText: this.$t('public.btn_yes'), // 确定按钮的文案
          cancelButtonText: this.$t('public.btn_cancel'), // 取消按钮的文案
          type: 'warning'
        }
      )
        .then(() => {
          sensorDeleteSensor({
            ids: row.id,
            edited: 1
          }).then(async ({ state }) => {
            await this.$resultHandle(state)
            this.getListFn()
          })
        })
        .catch(() => {})
    },
    /** 未确认的删除操作 */
    delFn () {
      if (this.choozeTableData.length === 0) {
        return this.$message.warning(this.$t('public.least_one_data'))
      }
      this.$confirm(
        this.$t('messageTitle.DeleteToContinue'),
        this.$t('public.prompt'),
        {
          confirmButtonText: this.$t('public.btn_yes'), // 确定按钮的文案
          cancelButtonText: this.$t('public.btn_cancel'), // 取消按钮的文案
          type: 'warning'
        }
      )
        .then(() => {
          const ids = this.choozeTableData.map(item => item.id).join(',')
          sensorDeleteSensor({
            ids,
            edited: 1
          }).then(async ({ state }) => {
            await this.$resultHandle(state)
            this.getListFn()
          })
        })
        .catch(() => {})
    },
    /** 未确认新增 */
    addFn () {
      this.isShowUnDialog = true
      this.unTitle = $t('integration.new_sensor')
      this.optareStatus = 'add'
      this.$nextTick(() => {
        this.$refs.chilren.clearValidate()
        this.$refs.chilren.typeId = null
      })
    },
    // 下划线转驼峰
    jsonToHump (obj) {
      const array = ['tag_id', 'scene_id']
      if (obj instanceof Array) {
        obj.forEach(function (v, i) {
          jsonToHump(v)
        })
      } else if (obj instanceof Object) {
        Object.keys(obj).forEach(key => {
          const newKey = this.underline2Hump(key)

          if (newKey !== key) {
            obj[newKey] = obj[key]
            if (array.indexOf(key) === -1) {
              delete obj[key]
            }
          }
          this.jsonToHump(obj[newKey])
        })
        return obj
      }
    },
    underline2Hump (s) {
      return s.replace(/_(\w)/g, function (all, letter) {
        return letter.toUpperCase()
      })
    },

    /** 未确认编辑 */
    editFn (row) {
      this.isShowUnDialog = true
      this.unTitle = $t('public.edit') + row.tagId
      this.optareStatus = 'edit'
      sensorGetSensorDetailInfo(row.id).then(({ result }) => {
        // this.$nextTick(() => {
        this.$refs.chilren.typeId = row.type
        // const appConfig = this.jsonToHump(removeNulls(result.appConfig))
        // const netConfig = this.jsonToHump(removeNulls(result.netConfig))
        // const sensor = this.jsonToHump(removeNulls(result.sensor))
        // const obj = { ...appConfig, ...netConfig, ...sensor }

        // 放到组件内自行处理
        this.editObj = result
      })
    },
    /** 未确认模板下载 */
    // tableTemplateFn() {
    //   getGeneraUploadTemplateFile('sensor', this.$i18n.locale).then((res) => {

    //   })
    // },
    /** 未确认的输入导入 */
    dataImportFn () {
      this.isShowImDialog = true
      this.$nextTick(() => {
        if (this.$refs.importDia.$refs.refFile) {
          this.$refs.importDia.$refs.refFile.clearFiles()
        }
      })
      // this.$refs.importDia.exportFile();
    },
    /** 修改范围 */
    getSence () {
      shareScope({ tab: 1 }).then(res => {
        if (res.state.code == 200) {
          this.scopeArray = res.result.filter(item => {
            return item.id > 0
          })
        }
      })
    },
    editScopeFn () {
      if (this.choozeTableData.length === 0) {
        return this.$message.warning(this.$t('public.least_one_data'))
      }
      const flag = this.distinguishTypeFn('sceneId')
      if (!flag) {
        return this.$message.error(
          $t('integration.the_selected_sensor_is_not_the_same_customer')
        )
      }
      this.isShowScope = true
      this.getSence()
      this.$nextTick(() => {
        this.$refs.scopedId.dioForm.sceneId = this.choozeTableData[0].sceneId
        this.$refs.scopedId.dioForm.ids = this.choozeTableData
          .map(item => item.id)
          .join(',')
      })
    },
    // 校准
    calibrationFn(){
      if (this.choozeTableData.length === 0) {
        return this.$message.warning(this.$t('public.least_one_data'))
      }
      this.isShowCalibration = true
      this.singleCalibration = false
    },
    calibrationImportFn(){
      this.isShowCaliImport = true
    },
    calibrationExpiredFn(){
      this.isShowCaliExpired = true
    },
    // 单条校准
    calibrationSignleFn(row){
      this.isShowCalibration = true
      this.rowData = { ...row }
      this.singleCalibration = true
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../../style/sensor.scss';

</style>
